<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">{{ $t("project_option.title") }}</h3>
      </div>
      <div class="box-body flex_body">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ $t("project_option.project_name") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="advertise_project_info.name"
                :placeholder="$t('project_option.project_name')"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ $t("project_option.project_active") }}</label>
              <input
                style="margin-left: 11rem"
                type="checkbox"
                v-model="advertise_project_info.activate"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ $t("project_option.project_banner") }}</label>
            </div>
            <button
              @click="triggerInputUploadBanner"
              class="btn btn-primary"
              style="width:100px;"
            >
              Upload
            </button>
          </div>
        </div>
        <div class="col-xs-6 logo-lg">
          <logo-crop
            @project_logo="GetProjectBanner"
            :file="uploadFile"
            ref="logoCrop"
          />
          <img
            v-if="!advertise_project_info.banner"
            width="200px;"
            :src="img_url.img_other_no_picture_available"
            class="resize-img-lg"
          />
          <img
            v-else
            width="200px;"
            class="resize-img-lg"
            :src="advertise_project_info.banner"
          />
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ $t("project_option.project_description") }}</label>
              <textarea
                :placeholder="$t('project_option.project_description')"
                class="form-control"
                v-model="advertise_project_info.description"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ $t("project_option.project_content") }}</label>
              <trumbowyg
                class="form-control"
                v-model="advertise_project_info.content"
                name="content"
              ></trumbowyg>
              <button
                style="border:none; background-color: white;outline-style: none;"
                @click="clickInputImage"
              >
                <i
                  style="font-size: 15pt;color: saddlebrown;"
                  class="fa fa-picture-o"
                  aria-hidden="true"
                ></i>
              </button>
              <span>{{ $t("project_option.project_insert_img") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer">
      <button
        type="button"
        class="btn btn-labeled btn-danger"
        @click="doCancel"
        style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
      >
        <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
        {{ $t("common.back") }}
      </button>

      <button
        type="button"
        class="btn btn-labeled btn-success pull-right"
        style="margin-right: 5px;"
        @click="onSave"
      >
        <span class="btn-label"> <i class="glyphicon glyphicon-ok"></i> </span>
        {{ $t("common.save") }}
      </button>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <input
      type="file"
      ref="upload_banner"
      accept="image/*"
      style="display:none"
      @change="onHandleUploadBanner"
    />
    <input
      type="file"
      style="display: none;"
      ref="ImageInput"
      :accept="mimes"
      @change="onHandleImage"
      @click="$refs.ImageInput.value = null"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";
import Loading from "vue-loading-overlay";
import Logo from "@/components/Logo/LogoCrop.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import axios from "axios";
import configuration from "@/lib/config";
// import utils from '@/lib/utils'

export default {
  name: "AdvertiseProjectInfoAdd",
  props: {
    mimes: {
      type: String,
      default: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"
    }
  },
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      advertise_project_info: {
        name: "",
        description: "",
        content: "",
        activate: false,
        banner: null
      },
      uploadFile: null,
      isLoading: false,
      token: null,
      media_dns: null,
      paste_image: null
    };
  },
  watch: {
    GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST: function() {
      this.advertise_project_info.name = this.GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST.project_name;
      this.advertise_project_info.description = this.GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST.project_description;
      this.advertise_project_info.content = this.GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST.project_content;
      this.advertise_project_info.banner = this.GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST.project_banner;
      this.advertise_project_info.activate = this.GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST.active;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ADVERTISE_PROJECT_INFO_DETAIL_LIST"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_TOKEN_UPLOAD",
      "ADD_NEW_ADVERTISE_PROJECT_INFORMATION",
      "GET_ADVERTISE_PROJECT_INFO_DETAIL",
      "UPDATE_ADVERTISE_PROJECT_INFORMATION"
    ]),
    triggerInputUploadBanner: function() {
      this.$refs.upload_banner.click();
    },
    onHandleUploadBanner: function() {
      let file = this.$refs.upload_banner.files[0];
      if (file.size > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("AdvertiseProjectInfoAdd.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.uploadFile = file;
        this.$refs.logoCrop.inputFile(file);
      }
    },
    GetProjectBanner: function(data) {
      this.advertise_project_info.banner = data;
    },
    doCancel() {
      this.$router.push({
        name: "AdvertiseProjectInfoList"
      });
    },
    onSave() {
      let id = parseInt(this.$route.params.id);
      let data = {
        project_name: this.advertise_project_info.name,
        project_banner: this.advertise_project_info.banner,
        project_description: this.advertise_project_info.description,
        project_content: this.advertise_project_info.content,
        project_activate: this.advertise_project_info.activate
      };
      this.isLoading = true;
      if (id != 0) {
        this.UPDATE_ADVERTISE_PROJECT_INFORMATION({ id: id, ...data })
          .then(
            function() {
              this.SUCCESS_TOAST();
              this.$router.push({
                name: "AdvertiseProjectInfoList"
              });
              this.isLoading = false;
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
              this.isLoading = false;
            }.bind(this)
          );
      } else {
        this.ADD_NEW_ADVERTISE_PROJECT_INFORMATION(data)
          .then(
            function() {
              this.isLoading = false;
              this.SUCCESS_TOAST();
              this.$router.push({
                name: "AdvertiseProjectInfoList"
              });
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    clickInputImage: function() {
      this.$refs.ImageInput.click();
    },
    onHandleImage: function() {
      let img = this.$refs.ImageInput.files[0];
      if (img.size > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("ProjectGeneralSettings.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", img);
        formData.append("directory", "documents/");
        axios({
          method: "POST",
          timeout: 6000,
          url: this.media_dns + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.token}` }
        })
          .then(
            function(res) {
              this.paste_image = res.data.domain + res.data.url;
              document.execCommand(
                "insertHTML",
                false,
                `<img style="width:150px" src='${this.paste_image}'>`
              );
              this.advertise_project_info.content += `<img style="width:150px" src='${
                this.paste_image
              }'>`;
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    }
  },
  mounted() {
    this.GET_TOKEN_UPLOAD()
      .then(
        function(res) {
          this.token = res.token;
          this.media_dns = res.domain;
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    let id = parseInt(this.$route.params.id);
    if (id != 0) {
      this.GET_ADVERTISE_PROJECT_INFO_DETAIL({ id: id });
    }
  },
  components: {
    Trumbowyg,
    loading: Loading,
    "logo-crop": Logo,
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style>
.flex_body {
  display: flex;
  flex-direction: column;
  min-height: 50vh;
}

.flex_between {
  display: flex;
  justify-content: space-between;
}
textarea {
  resize: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Advertise/AdvertiseProjectInfoAdd.vue